import { z } from "zod";

import { selectableGuideSchema } from "../selectableGuideSchema";
import { basePrayerSchema } from "./basePrayerSchema";

export const playablePrayerSchema = basePrayerSchema.extend({
  selectable_guides: z.array(selectableGuideSchema).optional(),
  selected_track_id: z.number().optional().nullable(),
});

export type PlayablePrayer = z.infer<typeof playablePrayerSchema>;
